import { render, staticRenderFns } from "./UpdateCabinet.vue?vue&type=template&id=e2f312f4&"
import script from "./UpdateCabinet.vue?vue&type=script&lang=js&"
export * from "./UpdateCabinet.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCabinet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports